// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2_LvB","messages":"Chat_messages__1bXFt","dateDivider":"Chat_dateDivider__1TQMD"};